import { supabase } from "./supabase";
import { fromDbEvent, toDbEventUpdate } from "../lib/mappers";

const listEvents = async (projectId) => {
  const { data, error } = await supabase
    .from("events")
    .select("id, project_id, line, operation, estimated_hours, actual_hours, start_at, end_at, remarks, sort_index")
    .eq("project_id", projectId)
    .order("sort_index", { ascending: true });

  if (error) throw error;
  return (data ?? []).map(fromDbEvent);
};

const createEvent = async ({ projectId, userId, event }) => {
  const payload = {
    project_id: projectId,
    user_id: userId,
    ...toDbEventUpdate(event),
  };

  const { data, error } = await supabase
    .from("events")
    .insert(payload)
    .select("id, project_id, line, operation, estimated_hours, actual_hours, start_at, end_at, remarks, sort_index")
    .single();

  if (error) throw error;
  return fromDbEvent(data);
};

const upsertEvents = async (events, projectId, userId) => {
  if (!events.length) return [];
  const payload = events.map((event) => ({
    id: event.id,
    project_id: projectId,
    user_id: userId,
    ...toDbEventUpdate(event),
  }));

  const { data, error } = await supabase
    .from("events")
    .upsert(payload, { onConflict: "id" })
    .select("id, project_id, line, operation, estimated_hours, actual_hours, start_at, end_at, remarks, sort_index");

  if (error) throw error;
  return (data ?? []).map(fromDbEvent);
};

const deleteEvent = async (eventId) => {
  const { error } = await supabase.from("events").delete().eq("id", eventId);
  if (error) throw error;
};

export { listEvents, createEvent, upsertEvents, deleteEvent };
